<template>
	<v-container>
		<v-toolbar v-if="editorInstance" dense class="mb-4">
			<v-btn-toggle v-model="activeStyles" multiple dense color="primary">
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleBold().run()"
					:active="editorInstance.isActive('bold')"
				>
					<iconify-icon icon="mdi:format-bold"></iconify-icon>
				</v-btn>
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleItalic().run()"
					:active="editorInstance.isActive('italic')"
				>
					<iconify-icon icon="mdi:format-italic"></iconify-icon>
				</v-btn>
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleStrike().run()"
					:active="editorInstance.isActive('strike')"
				>
					<iconify-icon icon="mdi:format-strikethrough"></iconify-icon>
				</v-btn>
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleUnderline().run()"
					:active="editorInstance.isActive('underline')"
				>
					<iconify-icon icon="mdi:format-underline"></iconify-icon>
				</v-btn>
			</v-btn-toggle>

			<v-divider vertical class="mx-2"></v-divider>

			<v-btn-toggle v-model="activeHeadings" multiple dense color="primary">
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleHeading({ level: 1 }).run()"
					:active="editorInstance.isActive('heading', { level: 1 })"
				>
					<iconify-icon icon="mdi:format-header-1"></iconify-icon>
				</v-btn>
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleHeading({ level: 2 }).run()"
					:active="editorInstance.isActive('heading', { level: 2 })"
				>
					<iconify-icon icon="mdi:format-header-2"></iconify-icon>
				</v-btn>
				<v-btn
					icon
					@click="editorInstance.chain().focus().toggleHeading({ level: 3 }).run()"
					:active="editorInstance.isActive('heading', { level: 3 })"
				>
					<iconify-icon icon="mdi:format-header-3"></iconify-icon>
				</v-btn>
			</v-btn-toggle>

			<v-divider vertical class="mx-2"></v-divider>

			<v-menu offset-y>
				<template v-slot:activator="{ props: menuProps }">
					<v-btn icon v-bind="menuProps">
						<iconify-icon icon="mdi:palette"></iconify-icon>
					</v-btn>
				</template>
				<v-list density="compact">
					<v-list-item
						v-for="color in textColors"
						:key="color.value"
						@click="editorInstance.chain().focus().setColor(color.value).run()"
					>
						<v-list-item-title :style="{ color: color.value }">{{ color.name }}</v-list-item-title>
					</v-list-item>
					<v-list-item @click="editorInstance.chain().focus().unsetColor().run()">
						<v-list-item-title>清除颜色</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>

			<v-menu offset-y>
				<template v-slot:activator="{ props: menuProps }">
					<v-btn icon v-bind="menuProps">
						<iconify-icon icon="mdi:marker"></iconify-icon>
					</v-btn>
				</template>
				<v-list density="compact">
					<v-list-item
						v-for="highlightColor in highlightColors"
						:key="highlightColor.value"
						@click="editorInstance.chain().focus().toggleHighlight({ color: highlightColor.value }).run()"
					>
						<v-list-item-title :style="{ backgroundColor: highlightColor.value }">
							{{ highlightColor.name }}
						</v-list-item-title>
					</v-list-item>
					<v-list-item @click="editorInstance.chain().focus().unsetHighlight().run()">
						<v-list-item-title>清除高亮</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>

			<v-divider vertical class="mx-2"></v-divider>

			<v-btn icon @click="editorInstance.chain().focus().setHorizontalRule().run()">
				<iconify-icon icon="mdi:minus"></iconify-icon>
			</v-btn>
			<v-btn icon @click="editorInstance.chain().focus().setHardBreak().run()">
				<iconify-icon icon="mdi:format-text-variant"></iconify-icon>
			</v-btn>
			<v-btn icon @click="editorInstance.chain().focus().undo().run()">
				<iconify-icon icon="mdi:undo"></iconify-icon>
			</v-btn>
			<v-btn icon @click="editorInstance.chain().focus().redo().run()">
				<iconify-icon icon="mdi:redo"></iconify-icon>
			</v-btn>

			<v-divider vertical class="mx-2"></v-divider>

			<v-btn icon @click="addImage">
				<iconify-icon icon="mdi:image"></iconify-icon>
			</v-btn>
			<v-btn icon @click="addLink">
				<iconify-icon icon="mdi:link"></iconify-icon>
			</v-btn>
			<v-btn icon @click="addTable">
				<iconify-icon icon="mdi:table"></iconify-icon>
			</v-btn>

			<v-spacer></v-spacer>

			<v-btn icon @click="toggleEditable">
				<iconify-icon :icon="isEditable ? 'mdi:lock-open-outline' : 'mdi:lock'"></iconify-icon>
			</v-btn>
		</v-toolbar>

		<TiptapRichEditor
			ref="tiptapEditorRef"
			v-model="editorContent"
			:min-height="minHeight"
			:editable="isEditable"
			@update="handleUpdate"
			@focus="handleFocus"
			@blur="handleBlur"
		/>
		<!--
				<v-card class="mt-4 pa-4">
					<v-card-title class="text-h6">当前编辑器 HTML 内容</v-card-title>
					<v-card-text>
						<pre>{{ editorContent }}</pre>
					</v-card-text>
				</v-card>

				<v-card class="mt-4 pa-4">
					<v-card-title class="text-h6">操作</v-card-title>
					<v-card-text>
						<v-btn class="mr-2" @click="clearContent">清空内容</v-btn>
						<v-btn @click="setNewContent">设置新内容</v-btn>
					</v-card-text>
				</v-card>-->
	</v-container>
</template>

<script setup>
import TiptapRichEditor from './TiptapRichEditor.vue'
import { ref, watch, onMounted, defineEmits } from 'vue'

// 确保路径正确
const props = defineProps({
	modelValue: {
		type: String,
		default: ''
	},
	minHeight: {
		type: Number,
		default: 100
	}
})

// TiptapRichEditor 组件的实例引用
const tiptapEditorRef = ref(null)
// 存储 Tiptap editor 实例，以便在父组件中操作
const editorInstance = ref(null)

const editorContent = ref('<p>欢迎使用 <strong>Tiptap</strong> 富文本编辑器和 <strong>Vuetify 3</strong>！</p>')
const isEditable = ref(true)

// 文本颜色选项
const textColors = [
	{ name: '黑色', value: '#000000' },
	{ name: '红色', value: '#EF5350' },
	{ name: '蓝色', value: '#2196F3' },
	{ name: '绿色', value: '#4CAF50' }
]

// 高亮颜色选项
const highlightColors = [
	{ name: '无高亮', value: 'unset' },
	{ name: '黄色', value: 'yellow' },
	{ name: '蓝色', value: 'blue' },
	{ name: '绿色', value: 'green' }
]

// 活跃的样式按钮，用于 v-btn-toggle
const activeStyles = ref([])
const activeHeadings = ref([])

// 监听 TiptapRichEditor 组件实例的加载，并获取 Tiptap editor 对象
watch(tiptapEditorRef, (newVal) => {
	if (newVal && newVal.editor) {
		editorInstance.value = newVal.editor
		// 监听 Tiptap 自身的 selectionUpdate 事件，用于更新工具栏按钮状态
		editorInstance.value.on('selectionUpdate', ({ editor }) => {
			activeStyles.value = []
			activeHeadings.value = []

			if (editor.isActive('bold')) activeStyles.value.push('bold')
			if (editor.isActive('italic')) activeStyles.value.push('italic')
			if (editor.isActive('strike')) activeStyles.value.push('strike')
			if (editor.isActive('underline')) activeStyles.value.push('underline')

			if (editor.isActive('heading', { level: 1 })) activeHeadings.value.push('h1')
			if (editor.isActive('heading', { level: 2 })) activeHeadings.value.push('h2')
			if (editor.isActive('heading', { level: 3 })) activeHeadings.value.push('h3')
		})
	}
})
watch(
	() => props.modelValue,
	(newVal) => {
		console.log('watch modelValue', newVal)
		editorContent.value = newVal
	}
)
const emit = defineEmits(['update:modelValue']) // 这里加上

const handleUpdate = (html) => {
	console.log('编辑器内容已更新 (Tiptap @update):', html)
	emit('update:modelValue', html)
}

const handleFocus = () => {
	console.log('编辑器聚焦')
}

const handleBlur = () => {
	console.log('编辑器失焦')
}

const clearContent = () => {
	if (editorInstance.value) {
		editorInstance.value.commands.clearContent()
	}
}

const setNewContent = () => {
	if (editorInstance.value) {
		editorInstance.value.commands.setContent(
			'<p style="color: blue;">这是父组件设置的 <span style="font-weight: bold;">新内容</span>。</p><ul><li>列表项 A</li><li>列表项 B</li></ul><p><img src="https://picsum.photos/200/100" alt="随机图片"></p>'
		)
	}
}

const toggleEditable = () => {
	isEditable.value = !isEditable.value
}

// 图片上传功能
const addImage = () => {
	const url = window.prompt('图片 URL:')
	if (url) {
		editorInstance.value.chain().focus().setImage({ src: url }).run()
	}
}

// 链接功能
const addLink = () => {
	const url = window.prompt('链接 URL:')
	if (url) {
		editorInstance.value.chain().focus().setLink({ href: url }).run()
	}
}

// 插入表格功能
const addTable = () => {
	editorInstance.value.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
}

onMounted(() => {
	editorContent.value = props.modelValue
})
</script>

<style scoped>
.editor-content-area {
	border: 1px solid #ddd;
	border-top: none; /* 工具栏已经有边框，这里不需要顶部边框 */
	border-radius: 0 0 4px 4px; /* 圆角只在底部 */
	padding: 10px;
}

pre {
	background-color: #f0f0f0;
	padding: 10px;
	border-radius: 4px;
	overflow-x: auto;
}
</style>
